/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/DataInput/components/DataCollectionTemplateLink.tsx.
 */

import React from "react";
import { DATA_COLLECTION_TEMPLATE } from "../dataCollectionTemplate";

interface DataCollectionTemplateLinkProps {
  className?: string;
  label?: string;
}

const DataCollectionTemplateLink: React.FC<DataCollectionTemplateLinkProps> = ({
  className,
  label = DATA_COLLECTION_TEMPLATE.label,
}) => (
  <a
    className={className}
    href={DATA_COLLECTION_TEMPLATE.href}
    download={DATA_COLLECTION_TEMPLATE.downloadName}
    target="_blank"
    rel="noopener noreferrer"
  >
    {label}
  </a>
);

/** React component — Data Collection Template Link. */
export default DataCollectionTemplateLink;
